<script setup lang="ts">
import ProjectView from "../components/projects/ProjectView.vue";
import { trainerDetails } from "../main.ts";

const trainer = trainerDetails;
</script>

<template>
    <MainMenu :trainer="trainer" highlight="projects" />
    <div class="app-wrapper mb-8">
        <ProjectView v-if="trainer" :trainer="trainer" />
        <div v-else>
            <Skeleton height="83px" class="mb-4"></Skeleton>
            <Skeleton height="59px" class="mb-4"></Skeleton>
            <Skeleton height="193px" class="mb-4"></Skeleton>
        </div>
    </div>
    <Footer />
</template>
